import { Dayjs } from 'dayjs';

import { SBaseDisplay, SDate } from '@summit/core';

import { EboObject } from '../base-classes/ebo-object';
import { Company } from '../organization/company/company';
import { Hub } from '../places/hub/hub';
import { CredentialHub } from './credential-hub';
import { CredentialParameters } from './credential-parameters.enum';
import { IntegrationConfiguration } from './integration-configuration';
import { ServiceMapping, ServiceProvider } from './service-provider.enum';
import { Tenant } from './tenant';

export class TenantCredential extends EboObject implements SBaseDisplay {
  name: string;
  tenantID: string;
  tenant: Tenant;
  service: ServiceProvider;
  enabled: boolean;
  archived: boolean;
  companyID: string;
  company: Company;
  hubID: number;
  hub: Hub;
  supportingHubs: CredentialHub[];
  includePnD: boolean;
  excludeLinehaul: boolean;
  startDate?: Dayjs;
  comment: string;
  secrets: string;
  parameters: CredentialParameters;
  integrationConfig: IntegrationConfiguration;

  //Hack for typing
  refNumber: number;
  servicePassword: string;
  serviceCode: string;
  oAuthUrl: string;

  constructor(jsonData: Partial<TenantCredential>) {
    super(jsonData);
    if (jsonData) {
      // ** Create complex objects
      if (jsonData.company) this.company = new Company(jsonData.company);
      if (jsonData.hub) this.hub = new Hub(jsonData.hub);
      if (jsonData.supportingHubs) this.supportingHubs = jsonData.supportingHubs.map((data) => new CredentialHub(data));
      if (jsonData.startDate) this.startDate = SDate.newUtc(jsonData.startDate);
      if (jsonData.integrationConfig) this.integrationConfig = new IntegrationConfiguration(jsonData.integrationConfig);
    }
    this.integrationConfig ??= new IntegrationConfiguration();
    this.archived ??= false;
    this.enabled ??= true;
    this.supportingHubs ??= new Array<CredentialHub>();
  }

  toShortString(): string {
    return `${ServiceMapping[this.service]}: ${this.name}`;
  }

  HasFlag(flag: CredentialParameters): boolean {
    // eslint-disable-next-line no-bitwise
    return flag === (this.parameters & flag);
  }

  SetFlag(flag: CredentialParameters, value: boolean) {
    if (value) {
      // eslint-disable-next-line no-bitwise
      this.parameters |= flag;
    } else {
      // eslint-disable-next-line no-bitwise
      this.parameters &= ~flag;
    }
  }
}
